import { render, staticRenderFns } from "./CompanyRestorationTask.vue?vue&type=template&id=7aa3609a&scoped=true&"
import script from "./CompanyRestorationTask.vue?vue&type=script&lang=js&"
export * from "./CompanyRestorationTask.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRestorationTask.vue?vue&type=style&index=0&id=7aa3609a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa3609a",
  null
  
)

export default component.exports